import './PdfViewer.css'

import React, {useEffect, useState} from "react";
import { useParams, useLocation } from "react-router-dom";
import SinglePagePDFViewer from "./pdf/single-page";

import ViewerService from "../../services/viewer.service";

const PdfViewerLegacy = () => {
    const { id } = useParams();
    const token = new URLSearchParams(useLocation().search).get('token');
    const [load, setLoad] = useState(true);
    const [url, setUrl] = useState('');


    useEffect(() => {
        initViewer();
    }, []);

    const initViewer = () => {
        ViewerService.getFileLegacy(id, token).then(
            (response) => {
                const blob = new Blob([response.data], { type: 'application/pdf' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    setUrl(window.URL.createObjectURL(blob));
                    window.navigator.msSaveOrOpenBlob(blob, response.filename);
                    setLoad(false);
                } else if(response.filename.endsWith('.pdf')) {
                    window.location.href = window.URL.createObjectURL(blob);
                } else {
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', response.filename); //or any other extension
                    document.body.appendChild(link);
                    link.click();
                }
            },
            (error) => {
                if (error.response.data.code == 'ERR_02') {
                    window.location.href = '/error/404';
                } else {
                    window.location.href = '/error/500';
                }
            }
        );

    };

    const isLoading = () => {
        if(load) {
            return (
                <div className="pdf-load">
                    <div className="spinner">
                        <div className="load-msg">
                            <h2>Veuillez patienter pendant le chargement du document...</h2>
                        </div>
                    </div>
                </div>
            )
        } else {
            return (
                <div className="pdf-container">
                    <SinglePagePDFViewer pdf={url} />
                </div>
            )
        }
    }

    return (
        <div className="pdf-viewer">
            { isLoading() }
        </div>
    );
};

export default PdfViewerLegacy;
